function MostrarEncabezadosActividades({actividades}) {       
    return (  
        <>
        {actividades.length>0 ? actividades.map((a, idx) => (
            <th key={a.es_evaluacion ? `eval_${a.id_eval}_${idx}` : `${a.id}_${idx}`} className='text-center align-middle'>
                {a.es_evaluacion ? (
                    <div>
                        <i className="fa-solid fa-file-signature text-primary me-1"></i>
                        {a.titulo}{' '}
                        <span className="badge bg-secondary">{a.modalidad === 'oral' ? 'Oral' : 'Escrita'}</span>
                    </div>
                ) : (
                    <>{a.titulo} ({a.id})</>
                )}
            </th>
        ))
        :
        ''
        }
        </>
    );
}

export default MostrarEncabezadosActividades;        